module.exports = __webpack_public_path__ + "img/partner-3.d6b86925.png";